import React, { useState, useEffect } from "react";
import Navbar from "../common/navbar/Navbar";
import Rightarrow from "../../assets/payment/arrowblck.svg";
import activity from "../../assets/food/activity.svg";
import fastFood from "../../assets/food/fastfood.svg";
import { Dialog } from "primereact/dialog";
import check from "../../assets/payment/checked 1.svg";
import offer from "../../assets/payment/offercard.png";
import offerArrow from "../../assets/payment/offer-card-arrow.svg";
import offerDetail from "../../assets/payment/offer-details.png";
import Passportvoucher from "../../assets/payment/voucher.png";
//import "../seat-layout/seatlayout.css";
import "./payment.css";
import { Sidebar } from "primereact/sidebar";
import axios from "axios";
import * as appConstants from "../../constants/index";
import PaytemPostpaid from "./frequentlyUsed/PaytmPostpaid";
import DebitCard from "./frequentlyUsed/DebitCard";
import NetBanking from "./frequentlyUsed/NetBanking";
import Upi from "./frequentlyUsed/Upi";
import JuspayUpiQR from "./frequentlyUsed/JuspayUpiWithScan";
import CreditCard from "./frequentlyUsed/CreditCard";
import SavedCard from "./frequentlyUsed/SavedCard";
import Paytm from "./wallets/Paytm";
import Mobikwik from "./wallets/Mobikwik";
import Phonepe from "./wallets/Phonepe";
import GiftCard from "./other-options/GiftCard";
import Privilegecard from "./other-options/Privilegecard";
import Gyftr from "./other-options/Gyftr";
import TicketXpress from "./other-options/TicketXpress";
import Starpass from "./pvr-exclusive/Starpass";
import Mcoupon from "./pvr-exclusive/Mcoupon";
import Promocode from "./pvr-exclusive/Promocode";
import HyattDining from "./pvr-exclusive/HyattDining";
import Login from "../common/login/Login";
import { useSelector, useDispatch } from "react-redux";
import { setLoginViewMode } from "../../redux/actions/loginViewAction";
import explore from "../../assets/payment/explore.svg";
import Bankoffer from "../../assets/payment/banker-offer.svg";
import Bankofferinox from "../../assets/payment/bank-offer-blue.svg";
import explore_pvr from "../../assets/payment/explore_pvr.svg";
import offerRight from "../../assets/payment/offer-right-arrow.svg";
import SeatLayoutBreadBrumb from "../common/app-breadcrumb/SeatLayoutBreadBrumb";
import { refraceTokenService } from "../../global-functions/refreshToken";
import GiftCardSummary from "./summary/GiftCardSummary";
import TicketSummary from "./summary/TicketSummary";
import { useNavigate } from "react-router-dom";
import { MainDiv } from "../common/app-breadcrumb/breadcrumbTag";
import { DonateButton } from "./paymentTags";
import savecard from "../../assets/payment/savecard.svg";
import SweetAlert from "react-bootstrap-sweetalert";
import BankOffers from "./bank-offers/BankOffers";
import { setGrandTotalamount } from "src/redux/actions/gradTotalAction";
import { applycoupon, removeCoupon } from "src/services/CouponPayment";
import PaymodesListSkeleton from "src/skeletons/PaymodesListSkeleton";
import { DarkButton } from "src/styled-components/customButtons";
import { FaRupeeSign } from "react-icons/fa";
import start_pvr from '../../assets/payment/star-pvr.jpeg'
import { hitGa } from "src/services/PassportServices";
import { datalayer as datalayernew } from "src/services/OtherServices";

const Payment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const subscription = localStorage.getItem('subscription');
  const [discount, setDiscount] = useState(null);
  const [cardNumber, setcardNumber] = useState(null);
  const [bankName, setBankName] = useState(null);
  const [searchText, setSearchText] = useState(null);
  const [applydata, setApplyData] = useState(null);
  const [ditxt, setDitxt] = useState(null);
  const [visible, setVisible] = useState(false);
  const [payment, setPayment] = useState(false);
  const [visibleRight, setVisibleRight] = useState(false);
  const [viewMode, setViewMode] = useState(0);
  const [loading, setLoading] = useState(false);
  const [juspayinit, setJuspayinit] = useState(0);
  const theme = localStorage.getItem("theme");
  const [activeButtonId, setActiveButtonId] = useState("201");
  const [activeOfferMode, setActiveOfferMode] = useState(false);
  const [paymentModes, setPaymentModes] = useState(null);
  const [payMode, setPayModes] = useState(null);
  const loginVewMode = useSelector((state) => state.loginViewMode.value);
  const [errorMsg, setErrorMsg] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [showVoucher, setshowVoucher] = useState(true);
  const [summaryData, setSummaryData] = useState(null);
  const [dependentCheckbox, setDependentCheckbox] = useState(0);
  const [isBankOfferApplied, setIsBankOfferApplied] = useState(false);
  const [enableCardID, setEnableCardID] = useState(null);
  const [loyalityVouchers, setloyalityVouchers] = useState([]);
  const grandTotal = useSelector((state)=> state.grandTotalData)
  //console.log(gradvalue);
  // console.log('activeButtonId', activeButtonId)
  useEffect(() => {
    if (localStorage.getItem("token")) {
      getJuspayInit();
      getPayModeLists();
      if(localStorage.getItem("booking_type") =='GIFTCARD'){
      
      hitGCGA();
      }
    } else {
      dispatch(setLoginViewMode({ value: true }));
    }
  }, [loginVewMode]);

  const SaveticketSummaryData = (data) => {
    console.log(data);
    setSummaryData(data);
  };
  const hitBeginCheckout = (
    event,
    item_brand,
    item_name,
    item_id,
    item_category,
    item_category2,
    item_category3,
    item_variant,
    quantity,
    price
  ) => {
    let dataLayer = window["dataLayer"] || [];
    dataLayer.push({
      event: event,
      ecommerce: {
        items: [
          {
            item_brand: item_brand,
            item_name: item_name,
            item_id: item_id,
            item_category: item_category, //(selected ticket, gift card & passport)
            item_category2: item_category2, //(selected f&b & city name)
            item_category3: item_category3, //( selected date & seat number)
            item_variant: item_variant, //( selected format)
            quantity: quantity,
            price: price,
          },
        ],
      },
    });
  };
  const removeApplyData = () =>{
    // console.log("working", applydata);
    removeApply(applydata?applydata.voucheName:'', applydata?applydata.vochId:"");
  }
  const sendDataForPayment = (index) => {
    // the callback. Use a better name

    console.log("sendDataForPayment", index);
    let dt = index;
    if (dt.result === "success") {
      setActiveButtonId("201");
      const ndt = dt.output;
      if(dt.voucheName) {
        setApplyData({voucheName:dt.voucheName});
      }
      //  console.log("setDonationData==>", ndt);
       if (ndt && ndt?.it && ndt?.ft) {
        // console.log(ndt);
        // setPassportDisamt(ndt?.ft);
        dispatch(
          setGrandTotalamount({
            cutPrice: Number(ndt?.it),
            finalPrice: Number(ndt?.ft),
          })
        );
      }
      setDitxt(ndt.txt);
      setshowVoucher(false);
      setPayment(true);
      setDiscount(JSON.stringify(ndt));
      if (ndt.p == true) {
        localStorage.setItem("booking_ticket", 1);
        navigate("/booking-ticket");
      }
      console.log(dt);
      if (dt.cardtype == "NB") {
        setBankName(dt.bankName);
        console.log(bankName);
      } else {
        setcardNumber(dt.cardNum);
      }
      if (dt.cardtype) {
        setActiveOfferMode(true);
        const val =
          dt.cardtype === "CC" ? "201" : dt.cardtype === "DC" ? "202" : "203";
        setEnableCardID(val);
        setActiveButtonId(val);
        setIsBankOfferApplied(true);
      }

      setLoading(false);
    } else if (dt.result === "dialog") {
      setErrorMsg(dt.msg);
      setShowAlert(true);
      setLoading(false);
    } else {
      setErrorMsg(dt.msg);
      setShowAlert(true);
      setLoading(false);
    }
  };

  const removeApply = async (type, couponId) => {
    setLoading(true);
    const postData = {
      ccode: localStorage.getItem("theaterId"),
      bookingId: localStorage.getItem("bookingid"),
      transId: localStorage.getItem("transid"),
      couponId: couponId,
      bookType: localStorage.getItem("booking_type")
        ? localStorage.getItem("booking_type")
        : "BOOKING",
      coupon: type == "PROMOCODE" ? searchText : couponId,
      couponType: type,
      qr: "NO",
      cardType: "",
      //"qrs": false,
      card: "",
      mobile: "",
      otp: "",
    };
    //removeCoupon
    removeCoupon(postData)
      .then((res) => {
        const dt = res.data;
        if (dt.result === "success") {
          const ndt = dt.output;
          //console.log("setDonationData==>", ndt);
          setDitxt(dt.msg);
          setshowVoucher(true);
          setPayment(true);
          setApplyData(null);
          setDiscount(JSON.stringify(ndt));
          setDependentCheckbox(0);
          setEnableCardID(null);
          setActiveButtonId("");
          setcardNumber("");
          //setDonationVewMode(false);
          // if(ndt === 'no'){
          //   setDonationPrice(0)
          // }
          setLoading(false);
        } else {
          setErrorMsg(dt.msg);
          setShowAlert(true);
          console.log(res.data.msg);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
      });
  };
  const getApply = async (type, couponId) => {
    setLoading(true);
    hitGa({
      'event': type
      })
    const postData = {
      ccode: localStorage.getItem("theaterId"),
      bookingId: localStorage.getItem("bookingid"),
      transId: localStorage.getItem("transid"),
      couponId: couponId,
      bookType: localStorage.getItem("booking_type")
        ? localStorage.getItem("booking_type")
        : "BOOKING",
      coupon: type == "PROMOCODE" ? searchText : couponId,
      couponType: type,
      qr: "NO",
      cardType: "",
      //"qrs": false,
      card: "",
      mobile: "",
      otp: "",
    };
    //removeCoupon
    applycoupon(postData)
      .then((res) => {
        const dt = res.data;
        if (dt.result === "success") {
          const ndt = dt.output;
          dt.voucheName = type;
          setActiveButtonId("");
          console.log("setDonationData==>", ndt);
          setDitxt(ndt.txt);
          setPayment(true);
          setshowVoucher(false);
          setDiscount(JSON.stringify(ndt));
          if (ndt.p == true) {
            navigate("/booking-ticket");
          }
          sendDataForPayment(dt);
          //setDonationVewMode(false);
          // if(ndt === 'no'){
          //   setDonationPrice(0)
          // }
          setLoading(false);
        } else {
          setErrorMsg(dt.msg);
          setShowAlert(true);
          console.log(res.data.msg);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
      });
  };
  const hitCancelTicket = () => {
    let dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "booking_now_with_ticket_cancellation",
      ecommerce: {
        items: [
          {
            item_brand: appConstants.cinemaChain, //(pvr/inox)
            item_name: localStorage.getItem("movie_name"),
            item_id: localStorage.getItem("movieid"),
            item_category: "ticket", //(selected ticket, gift card & passport)
            quantity: localStorage.getItem("quantity"),
            price: localStorage.getItem("price"),
          },
        ],
      },
    });
  };
  const getJuspayInit = async () => {
    setLoading(true);
    const postData = {
      transId: localStorage.getItem("transid"),
      bookingId: localStorage.getItem("bookingid"),
      bookType: localStorage.getItem("booking_type"),
      paytype: "",
      pgtype: "",
    };

    await axios
      .post(`${appConstants.base_url}v1/payment/juspay/init`, postData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
          chain: theme === "inoxTheme" ? "INOX" : "PVR",
          city: localStorage.getItem("city"),
          appVersion: appConstants.av,
          platform: appConstants.pt,
          country: appConstants.cname,
        },
      })
      .then((res) => {
        const dt = res.data;
        if (dt.result === "success") {
          dt.subscription = subscription;
          setJuspayinit(dt.output);
          // console.log("init==>", dt.output);
        } else {
          console.log(res.data.msg);
        }
      })
      .catch((error) => {
        const err = error?.response;
        if (err && err?.status === 403) {
          refraceTokenService();
          console.log(
            "Forbidden: You do not have permission to access this resource."
          );
        } else {
          console.log("Error:", error?.message);
        }
        setLoading(false);
      });
  };

  const getPayModeLists = async () => {
    setLoading(true);
    const postData = {
      ccode: localStorage.getItem("theaterId"),
      bookingId: localStorage.getItem("bookingid"),
      transId: localStorage.getItem("transid"),
      bookType: localStorage.getItem("booking_type"),
    };
    // console.log("token", `Bearer ${loginInfo.access.token}`)

    await axios
      .post(`${appConstants.base_url}v1/booking/ticketing/paymodes`, postData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          chain: theme === "inoxTheme" ? "INOX" : "PVR",
          city: localStorage.getItem("city"),
          appVersion: appConstants.av,
          platform: appConstants.pt,
          country: appConstants.cname,
        },
      })
      .then((res) => {
        const dt = res.data;
        if (dt.result === "success") {
          const ndt = dt.output;

          setPaymentModes(ndt);
          // hitGa({
          //   'event': 'begin_checkout',
          //   'item_brand' : 'PVRINOX',
          //   'item_category' : 'Passport', 
          //   'item_category2' : localStorage.getItem("city"),
          //   'item_category3' : new Date()
          //   })
            datalayernew({
              event: 'begin_checkout',
              ecommerce: {
                currency: 'INR',
                value: parseFloat(grandTotal.finalPrice),
                items: [{          
                'item_brand': 'PVRINOX',    
                'item_category': 'Passport',          //(selected ticket, gift card & passport)
                'item_category2': localStorage.getItem("city"),                        //(selected city name)
                'item_category3': new Date(),                      //( selected date & time)
                'quantity': 1,
                'price': parseFloat(grandTotal.finalPrice)
                 //'item_variant': 'IMAX/4DX',                      //( selected format)
                }]
              }
            })
          //loyalityVoucher();
          // console.log("payModeData==>", ndt);
          setLoading(false);
        } else if (res.data.code === 12001) {
          // alert(res.data.msg);
          setLoading(false);
        } else {
          console.log(res.data.msg);
          setLoading(false);
        }
      })
      .catch((error) => {
        const err = error?.response;
        if (err?.status === 403) {
          // refraceTokenService();
          console.log(
            "Forbidden: You do not have permission to access this resource."
          );
        } else {
          console.log("Error:", error?.message);
        }
        setLoading(false);
      });
  };

  // for loyality voucher

  // const loyalityVoucher = () =>{
  //   getLoyalityVoucher().then((res)=>{
  //     const dt = res.data;
  //     if (dt.result === "success") {
  //       setloyalityVouchers(dt.output);
  //     } else {

  //     }
  //   }).catch((error)=>{
  //     const err = error?.response;
  //      console.log(err);
  //      if (err?.status === 403) {
  //        refraceTokenService();
  //        //profileRequest();
  //        console.log(
  //          "Forbidden: You do not have permission to access this resource."
  //        );
  //      } else {
  //        console.log("Error:", error.message);
  //      }
  //  })
  // }

  // === sidebar offer UI =============
  const sidebarOfferUi = () => {
    return (
      <>
        <div className="offer-explore">
          <div className="offer-your">
            <div className="offer-title">
              <h5>Offers for you</h5>
            </div>
            <div className="offer-cross">
              <span onClick={() => setVisibleRight(false)}>
                <i className="pi pi-times"></i>
              </span>
            </div>
          </div>
          <div className="offering-line"></div>
          <div className="offer-cards" onClick={() => setViewMode(1)}>
            <div className="offer-card-photo">
              <img src={offer} alt="" className="img-fluid" />
            </div>
            <div className="offer-cards-content">
              <div className="arrow-offer">
                <div className="arrow-head">
                  <h6>20% off on Kotak Cards</h6>
                </div>
                <div className="arrow-icon">
                  <img src={offerArrow} alt="" className="img-fluid" />
                </div>
              </div>
              <p>Valid till 20 Aug 2022</p>
            </div>
          </div>
          <div className="offer-cards" onClick={() => setViewMode(1)}>
            <div className="offer-card-photo">
              <img src={offer} alt="" className="img-fluid" />
            </div>
            <div className="offer-cards-content">
              <div className="arrow-offer">
                <div className="arrow-head">
                  <h6>20% off on Kotak Cards</h6>
                </div>
                <div className="arrow-icon">
                  <img src={offerArrow} alt="" className="img-fluid" />
                </div>
              </div>
              <p>Valid till 20 Aug 2022</p>
            </div>
          </div>
          <div className="offer-cards" onClick={() => setViewMode(1)}>
            <div className="offer-card-photo">
              <img src={offer} alt="" className="img-fluid" />
            </div>
            <div className="offer-cards-content">
              <div className="arrow-offer">
                <div className="arrow-head">
                  <h6>20% off on Kotak Cards</h6>
                </div>
                <div className="arrow-icon">
                  <img src={offerArrow} alt="" className="img-fluid" />
                </div>
              </div>
              <p>Valid till 20 Aug 2022</p>
            </div>
          </div>
          <div className="offer-cards" onClick={() => setViewMode(1)}>
            <div className="offer-card-photo">
              <img src={offer} alt="" className="img-fluid" />
            </div>
            <div className="offer-cards-content">
              <div className="arrow-offer">
                <div className="arrow-head">
                  <h6>20% off on Kotak Cards</h6>
                </div>
                <div className="arrow-icon">
                  <img src={offerArrow} alt="" className="img-fluid" />
                </div>
              </div>
              <p>Valid till 20 Aug 2022</p>
            </div>
          </div>
        </div>
      </>
    );
  };

  const cardBreadcrumb = () => {
    return (
      <>
        <MainDiv>
          <div className="seat-bread-gift">
            <ul>
              <li
                className="backs"
                onClick={() => navigate(-1)}
                style={{ cursor: "pointer" }}
              >
                <span className="arrow-backs">
                  {" "}
                  <img src={Rightarrow} alt="" className="img-fluid" />
                </span>
                Back
              </li>
              <li> Delivery Details </li>
              <li className="">Order Summary</li>
              <li className="prev">
                <u>Payment</u>
              </li>
            </ul>
          </div>
        </MainDiv>
      </>
    );
  };
 const hitGCGA =()=> {
  let dataLayer = window["dataLayer"] || [];
  dataLayer.push({
event: "gift_card_proceed_to_pay",
'gift_card_type': localStorage.getItem("giftCardDatatype"),
'gift_card_no': localStorage.getItem("giftCardDatadisplay"),
'gift_card_amount': localStorage.getItem("giftCardDatadenominations"),
});
}
  return (
    <>
      <SweetAlert
        error
        show={showAlert}
        title={errorMsg}
        onConfirm={() => {
          setShowAlert(false);
          // console.log('confirm')
          //navigate('/')
        }}
        onCancel={() => setShowAlert(false)}
        confirmBtnCssClass={
          theme === "inoxTheme"
            ? "confirm-btn-inox border-0"
            : "confirm-btn-pvr border-0"
        }
      >
        {/* {errorMsg} */}
      </SweetAlert>
      <div
        className="bg-white"
        style={{ position: "sticky", top: "0", zIndex: "999" }}
      >
        <Navbar disable={true} />
      </div>
      <section className="bg-seatlayout">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9 seat-views">
              {localStorage.getItem("booking_type") === "GIFTCARD" ? (
               
                cardBreadcrumb()
              ) : localStorage.getItem("booking_type") === "BOOKING"? (
                <SeatLayoutBreadBrumb />
              ):""}
              <div className="row payment-spaces ">
                <div className="col-xl-3 col-md-4 col-12">
                  {loading ? (
                    <PaymodesListSkeleton />
                  ) : (
                    <div className="payment-method">
                      {paymentModes?.vouchers.length > 0 ||
                        paymentModes?.bankoffers.length > 0 ||
                        paymentModes?.offers.length > 0 ? (
                        <>
                          <h6>Offers & Promotions</h6>
                          <ul className={!showVoucher ? "btn-opacity" : ""}>
                            {paymentModes?.vouchers.length > 0 ? (
                              <li
                                style={{ cursor: "pointer" }}
                                className={
                                  activeButtonId === "EXOF"
                                    ? "payment-active"
                                    : ""
                                }
                                onClick={() => {
                                  setActiveButtonId("EXOF");
                                }}
                              >
                                <span className="paytm-photo">
                                  <img
                                    src={
                                      theme === "inoxTheme"
                                        ? explore
                                        : explore_pvr
                                    }
                                    alt=""
                                    className="img-fluid"
                                    width={25}
                                    height={20}
                                  />
                                </span>
                                Explore Offers
                              </li>
                            ) : (
                              ""
                            )}
                            {paymentModes?.bankoffers.length > 0 ? (
                              <li
                                style={{ cursor: "pointer" }}
                                className={
                                  activeButtonId === "BKOF"
                                    ? "payment-active"
                                    : ""
                                }
                                onClick={() => {
                                  setActiveButtonId("BKOF");
                                }}
                              >
                                <span className="paytm-photo">
                                  <img
                                    src={
                                      theme === "inoxTheme"
                                        ? Bankofferinox
                                        : Bankoffer
                                    }
                                    alt=""
                                    className="img-fluid"
                                    width={25}
                                    height={20}
                                  />
                                </span>
                                Bank Offers
                              </li>
                            ) : (
                              ""
                            )}

                            {paymentModes &&
                              paymentModes.offers.map((item, idx) => (
                                <li
                                  key={idx}
                                  className={
                                    activeButtonId === item.pid
                                      ? "payment-active"
                                      : ""
                                  }
                                  onClick={() => {
                                    setActiveButtonId(item.pid);
                                    setPayModes(item);
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  <span className="paytm-photo">
                                    <img
                                      src={
                                        theme === "inoxTheme"
                                          ? item.imageUrl
                                          : start_pvr
                                      }
                                      alt=""
                                      className="img-fluid"
                                      width={25}
                                      height={20}
                                    />
                                  </span>
                                  {item.name}
                                </li>
                              ))}
                          </ul>
                        </>
                      ) : (
                        ""
                      )}
                      <h6>{paymentModes?.gateway && "PAYMENT METHODS"}</h6>
                      <ul>
                        {paymentModes && paymentModes?.savedcard && juspayinit && juspayinit.list_cards.length > 0 ? (
                          <li
                            className={
                              activeButtonId !== "197000"
                                ? ""
                                : theme === "inoxTheme"
                                ? "payment-active-inox"
                                : "payment-active-pvr"
                            }
                            onClick={() => {
                              // window.scrollTo({
                              //   top:
                              //     25 *
                              //     parseFloat(
                              //       getComputedStyle(document.documentElement)
                              //         .fontSize
                              //     ),
                              //   left: 0,
                              //   behavior: "smooth",
                              // });
                              setActiveButtonId("197000");
                            }}
                            style={!enableCardID ? { cursor : "pointer" }:{ "pointer-events" : "none" ,     opacity: 0.4}}
                          >
                            <span className="paytm-photo">
                              <img
                                src="https://originserver-static1-uat.pvrcinemas.com/pvrcms/paymodes/credircard_68643_oKs6qiQS.png"
                                alt=""
                                className="img-fluid"
                                width={25}
                                height={20}
                              />
                            </span>
                            Saved Card
                          </li>
                        ) : (
                          ""
                        )}
                        {paymentModes &&
                          [...paymentModes?.gateway]?.map((item, idx) => (
                             
                                <li
                                  key={idx}
                                  className={
                                    activeButtonId !== item.pid
                                      ? ""
                                      : theme === "inoxTheme"
                                      ? "payment-active-inox"
                                      : "payment-active-pvr"                                     
                                  }
                                  onClick={() => {
                                    // window.scrollTo({
                                    //   top:
                                    //     25 *
                                    //     parseFloat(
                                    //       getComputedStyle(document.documentElement)
                                    //         .fontSize
                                    //     ),
                                    //   left: 0,
                                    //   behavior: "smooth",
                                    // });
                                    setActiveButtonId(item.pid);
                                    setPayModes(item);
                                  }}
                                  style={!enableCardID || (enableCardID && enableCardID == item.pid)?{ cursor : "pointer" }:{ "pointer-events" : "none" ,     opacity: 0.4}}
                                >
                                  <span className="paytm-photo">
                                    <img
                                      src={item.imageUrl}
                                      alt=""
                                      className="img-fluid"
                                      width={25}
                                      height={20}
                                    />
                                  </span>
                                  {item.name}
                                </li>
                              
                          ))}
                      </ul>
                      {paymentModes && paymentModes?.wallets.length >0 ?
                          <h6>{paymentModes?.wallets && "WALLETS"}</h6>
                      :""}
                          <ul>
                            {paymentModes &&
                              paymentModes?.wallets?.map((item, idx) => (
                                <li
                                  key={idx}
                                  className={
                                    activeButtonId !== item.pid
                                      ? ""
                                      : theme === "inoxTheme"
                                      ? "payment-active-inox"
                                      : "payment-active-pvr"
                                  }
                                  onClick={() => {
                                    // window.scrollTo({
                                    //   top:
                                    //     25 *
                                    //     parseFloat(
                                    //       getComputedStyle(document.documentElement)
                                    //         .fontSize
                                    //     ),
                                    //   left: 0,
                                    //   behavior: "smooth",
                                    // });
                                    setActiveButtonId(item.pid);
                                    setPayModes(item);
                                  }}
                                  style={!enableCardID ? { cursor : "pointer" }:{ "pointer-events" : "none" , opacity: 0.4}}
                                >
                                  <span className="paytm-photo">
                                    <img
                                      src={item.imageUrl}
                                      alt=""
                                      className="img-fluid"
                                      width={25}
                                      height={20}
                                    />
                                  </span>
                                  {item.name}
                                </li>
                              ))}
                          </ul>
                      {/* <h6>{paymentModes?.offers && "EXCLUSIVE OFFERS"}</h6>
                      <ul>
                        {paymentModes &&
                          paymentModes.offers.map((item, idx) => (
                            <li
                              key={idx}
                              className={
                                activeButtonId !== item.pid
                                  ? ""
                                  : theme === "inoxTheme"
                                  ? "payment-active-inox"
                                  : "payment-active-pvr"
                              }
                              onClick={() => {
                                window.scrollTo({
                                  top:
                                    25 *
                                    parseFloat(
                                      getComputedStyle(document.documentElement)
                                        .fontSize
                                    ),
                                  left: 0,
                                  behavior: "smooth",
                                });
                                setActiveButtonId(item.pid);
                                setPayModes(item);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <span className="paytm-photo">
                                <img
                                  src={item.imageUrl}
                                  alt=""
                                  className="img-fluid"
                                  width={25}
                                  height={20}
                                />
                              </span>
                              {item.name}
                            </li>
                          ))}
                      </ul> */}
                    </div>
                  )}
                </div>
                <div className="col-xl-9 col-md-8 col-12">
                  <div className="payment-form">
                    <div className="paywithdebit">
                      <div className="debit-card">
                        <h6>To be Paid:</h6>
                      </div>
                      <div className="to-paid">
                        <p>
                        {grandTotal && grandTotal.cutPrice > 0? 
                          <span className="price-cross">
                            <FaRupeeSign style={{fontSize:"10px", fontWeight:"500", marginBottom:"2px"}}/>
                            {parseFloat(
                              grandTotal.cutPrice
                            ).toFixed(2)}
                          </span>
                          :''}
                          {/* <span className="price-cross">₹8888</span>{" "} */}
                          <span className="price-blod">
                            <FaRupeeSign
                              style={{
                                fontSize: "10px",
                                fontWeight: "500",
                                marginBottom: "2px",
                              }}
                            />
                            {
                            grandTotal && grandTotal.finalPrice ? grandTotal.finalPrice:''}
                          </span>
                        </p>
                      </div>
                    </div>
                    { (loyalityVouchers && loyalityVouchers.length > 0) || (paymentModes &&
                        paymentModes.autoVouchers.length > 0) || true ?
                    <div class="saveauto">
                      <div className="row">
                      { loyalityVouchers &&
                          loyalityVouchers.length > 0 ? 
                        <div className="col-md-12">
                          <div className="voucher">
                            <h6>AVAILABLE Vouchers</h6>
                          </div>
                        </div>
                      :""}
                        <div className="avail-voucher">
                          { loyalityVouchers &&
                          loyalityVouchers.length > 0 ? (
                            <>
                            {loyalityVouchers.map((item, idx) => {
                                return (
                                    <div className="voucher-redmeeauto">
                                      <div className="voucher-passport">
                                        <img src={Passportvoucher} alt="" className="" />
                                      </div>
                                      <div className="redmee-auto-fil">
                                        <div className="passport-voucher">
                                          <div className="tick-cricle-passport">
                                            <label>
                                              <input type="checkbox" />
                                              <div class="custom-checkbox">
                                                <div class="tick"></div>
                                              </div>
                                            </label>
                                          </div>
                                          <div className="passport-redmee">
                                            <p>{item.voucher}</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                )})
                              }
                            </>
                          ) : (
                            ""
                          )}
                        </div>

                        { paymentModes &&
                        paymentModes.autoVouchers.length > 0 ? (
                          <>
                            <div className="col-md-12">
                              <div className="voucher">
                                <h6>offers</h6>
                              </div>
                            </div>
                            <div className={!showVoucher?"auto-voucher btn-opacity":"auto-voucher"} >
                              {paymentModes.autoVouchers.map((item, idx) => {
                                return (
                                  <div className="offer-box-save">
                                    <div
                                      className="passport-voucher"
                                      onClick={() => {
                                        setApplyData({voucheName:"AUTOVOUCHER", vochId:item.vouId});
                                        !loading
                                          ? dependentCheckbox == 0
                                            ? getApply(
                                                "AUTOVOUCHER",
                                                item.vouId
                                              )
                                            : removeApply(
                                                "AUTOVOUCHER",
                                                item.vouId
                                              )
                                          : "";
                                        !loading
                                          ? dependentCheckbox == 0
                                            ? setDependentCheckbox(idx + 1)
                                            : setDependentCheckbox(0)
                                          : "";
                                        console.log(
                                          dependentCheckbox,
                                          idx,
                                          idx + 1
                                        );
                                      }}
                                    >
                                      <div className="tick-cricle-passport">
                                        <label>
                                          <input
                                            type="checkbox"
                                            checked={
                                              dependentCheckbox == idx + 1
                                            }
                                            disabled={
                                              dependentCheckbox > 0 &&
                                              dependentCheckbox != idx + 1
                                            }
                                          />
                                          <div class="custom-checkbox">
                                            <div class="tick"></div>
                                          </div>
                                        </label>
                                      </div>
                                      <div className="passport-redmee">
                                        <h5>{item.vouDesc}</h5>
                                        <h6>Click to view details</h6>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                        {!applydata?.voucheName?
                          <div className="col-md-12 col-12 ">
                            <div className="offers-start">
                              <div className="coupon-input">
                              {applydata?.voucheName == "PROMOCODE"?
                                <p><span><b>{searchText}</b></span> Applied</p>
                                :<input
                                  type="text"
                                  maxlength="18"
                                  className="offer-control"
                                  placeholder="Enter Promocode"
                                  value={searchText}
                                  onChange={(e) =>
                                    setSearchText(e.target.value.toUpperCase())
                                  }
                                />
                              }
                              </div>
                              <div className="apply-offers">
                              {applydata?.voucheName == "PROMOCODE"? <>
                                <DarkButton
                                onClick={() =>
                                  !loading ? removeApplyData() : ""
                                }
                                className={searchText ? 'btn-apply': "btn-apply btn-opacity"}
                              >
                                Remove
                              </DarkButton>
                              </>:
                                <DarkButton
                                  onClick={() =>
                                    !loading ? getApply("PROMOCODE", 0) : ""
                                  }
                                  className={searchText && !loading ? 'btn-apply': "btn-apply btn-opacity"}
                                >
                                  Apply
                                  {loading ? (
                                    <i
                                      className="pi pi-spin pi-spinner"
                                      style={{ fontSize: "1.5em" }}
                                    ></i>
                                  ) : (
                                    ""
                                  )}
                                </DarkButton>
                              }
                              </div>
                            </div>
                          </div> 
                        :""}
                      </div>
                    </div>
                    :""}
                  </div>
                  <div className="all-type-payment">
                    {activeButtonId === 9 ? (
                      <PaytemPostpaid />
                    ): activeButtonId === "EXOF" ? (
                      <BankOffers
                        offerType="Explore"
                        sendDataForPayment={sendDataForPayment}
                        payMode={paymentModes}
                        imgUrl={theme === "inoxTheme" ? explore : explore_pvr}
                        viewMode={1}
                      />
                    ) : activeButtonId === "BKOF" ? (
                      <BankOffers
                        offerType="Bank"
                        sendDataForPayment={sendDataForPayment}
                        payMode={paymentModes}
                        imgUrl={
                          theme === "inoxTheme" ? Bankofferinox : Bankoffer
                        }
                        viewMode={2}
                      />
                    ) : activeButtonId === "197000" ? (
                      <SavedCard
                        juspayinit={juspayinit}
                        payMode={paymentModes}
                      />
                    ) : activeButtonId === "202" ? (
                      <DebitCard
                        juspayinit={juspayinit}
                        payMode={payMode}
                        cardNum={cardNumber}
                        isBankOfferApplied={isBankOfferApplied}
                      />
                    ) : activeButtonId === "203" ? (
                      <NetBanking
                        juspayinit={juspayinit}
                        payMode={payMode}
                        bankName={bankName}
                      />
                    ) : activeButtonId === "204" ? (
                      <JuspayUpiQR juspayinit={juspayinit} payMode={payMode} promotionText={paymentModes?.promotionText} />
                    ) : activeButtonId === "201" ? (
                      <CreditCard
                        juspayinit={juspayinit}
                        payMode={payMode}
                        cardNum={cardNumber}
                        isBankOfferApplied={isBankOfferApplied}
                      />
                    ) : activeButtonId === "W101" ? (
                      <Paytm juspayinit={juspayinit} payMode={payMode} />
                    ) : activeButtonId === "W014" ? (
                      <Mobikwik juspayinit={juspayinit} payMode={payMode} />
                    ) : activeButtonId === 22 ? (
                      <Phonepe />
                    ) : activeButtonId === "105" ? (
                      <GiftCard sendDataForPayment={sendDataForPayment} />
                    ) : activeButtonId === 31 ? (
                      <Privilegecard />
                    ) : activeButtonId === "O108" ? (
                      <Gyftr
                        name={"Gyftr"}
                        type={"GYFTR"}
                        sendDataForPayment={sendDataForPayment}
                      />
                    ) : activeButtonId === "O111" ? (
                      // <TicketXpress />
                      <Gyftr
                        name={"Ticket Xpress"}
                        type={"TICKETXPRESS"}
                        sendDataForPayment={sendDataForPayment}
                      />
                    ) : activeButtonId === "O105" ? (
                      <Starpass
                        ticketSummary={summaryData}
                        sendDataForPayment={sendDataForPayment}
                      />
                    ) : activeButtonId === "O102" ? (
                      <Mcoupon
                        ticketSummary={summaryData}
                        sendDataForPayment={sendDataForPayment}
                      />
                    ) : activeButtonId === "O104" ? (
                      // <Promocode />
                      <Gyftr
                        name={"Promocode"}
                        type={"PROMOCODE"}
                        sendDataForPayment={sendDataForPayment}
                      />
                    ) : activeButtonId === 43 ? (
                      <HyattDining />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-3 col-12 book-summary">
              {localStorage.getItem("booking_type") === "GIFTCARD" || localStorage.getItem("booking_type") === "PASSPORT" ? (
                <GiftCardSummary discount={discount} removeApply={removeApplyData}
                applyData = {applydata} />
              ) : (
                <TicketSummary
                  discount={discount}
                  ticketSummaryData={SaveticketSummaryData}
                  removeApply={removeApplyData}
                  applyData = {applydata}
                />
              )}
            </div>
          </div>
        </div>
      </section>
      <div>
        <Dialog
          header=""
          visible={loginVewMode}
          // modal={false}
          showHeader={false}
          showCloseIcon={false}
          style={{ width: "40vw" }}
          onHide={() => dispatch(setLoginViewMode({ value: false }))}
          className="register-mobile"
        >
          <div className="row">
            <Login />
          </div>
        </Dialog>
      </div>
      <div className="card flex justify-content-center">
        <Dialog
          header=""
          visible={visible}
          modal={false}
          showHeader={false}
          showCloseIcon={false}
          style={{ width: "50vw" }}
          onHide={() => setVisible(false)}
          className="ticke-cancel-modal"
        >
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="cross-icon">
                <span
                  onClick={() => {
                    setVisible(false);
                  }}
                >
                  <i className="pi pi-times"></i>
                </span>
              </div>
              <div className="ticket-terms">
                <h1>Ticket Cancellation</h1>
                <div className="refund-food">
                  <h4>
                    <span className="iconfood">
                      <img src={fastFood} alt="" className="img-fluid" />
                    </span>
                    100% Refund on F&B
                  </h4>
                </div>
                <div className="refund-movies">
                  <h4>
                    <span className="iconfood">
                      <img src={activity} alt="" className="img-fluid" />
                    </span>
                    Up to 75% Refund for Tickets
                  </h4>
                  <p>75% refund until 2 hours before show start time.</p>
                  <p>
                    50% refund between 2 hours and 20 minutes before show start
                    time.
                  </p>
                </div>
                <div className="refund-voucher">
                  <p>
                    *Refund not available for Convenience fees, Vouchers, Gift
                    Cards, Taxes etc.
                  </p>
                  <p className="cancellation">
                    *No Cancellation within 20 minutes of show start time.
                  </p>
                </div>
                <div className="view-terms">
                  <p>View Terms & Conditions</p>
                </div>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
      <div className="card flex justify-content-center">
        <Dialog
          header=""
          visible={payment}
          modal={false}
          showHeader={false}
          showCloseIcon={false}
          style={{ width: "35vw" }}
          onHide={() => setPayment(false)}
          className="ticke-cancel-modal"
        >
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="cross-icon">
                <span onClick={() => setPayment(false)}>
                  <i className="pi pi-times"></i>
                </span>
              </div>
              <div className="saved-amount">
                <div className="checked-applied">
                  <img src={check} alt="" className="img-fluid check-icon" />
                  <p>Success</p>
                  <h4 dangerouslySetInnerHTML={{ __html: ditxt }}></h4>
                  {/* <p className="promo">using {searchText}</p> */}
                  <div className="awesome">
                    <DarkButton
                      className="awesome"
                      onClick={() => {
                        setViewMode(3);
                        setPayment(false);
                      }}
                    >
                      Awesome!
                    </DarkButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    </>
  );
};

export default Payment;
